<template>
	<page-common type="ask-detail" :has-comments="hasComments" :detail="detail" :auto-open-app="false">
		<div class="m-header">
			<h2 class="title f-taj">{{detail.title}}</h2>
			<div class="type">
				<span v-if="showDomain">{{detail.domain}}</span>
				<i class="dot"></i>
				<span>{{detail.type}}</span>
			</div>
		</div>
		<div class="m-content">
			<div class="item m-f-q">
				<user-avatar :avatar="fQ.avatar"></user-avatar>
				<div class="name f-toe1">{{fQ.user_name}}</div>
				<div class="to f-cb">
					<span class="f-fl f-toe1 name-a"><span class="prefix">向</span>{{detail.answer_user_name}}</span>
					<span class="f-fl suffix">提问</span>
				</div>
				<div class="date">{{fQ.date_timestamp | dateFormat1('yyyy-MM-dd hh:mm')}}</div>
				<div class="text">
					<pre class="f-pre" v-html="fQ.content"></pre>
				</div>
			</div>
			<div class="item m-f-a" v-if="showFA">
				<user-avatar :avatar="fA.avatar"></user-avatar>
				<div class="name f-toe1">{{fA.user_name}}</div>
				<div class="date">{{fA.date_timestamp | dateFormat1('yyyy-MM-dd hh:mm')}}</div>
				<div class="text">
					<pre class="f-pre" v-html="fA.content"></pre>
				</div>
			</div>
			<div class="item m-s-q" v-if="showSQ">
				<user-avatar :avatar="sQ.avatar"></user-avatar>
				<div class="name f-toe1">{{sQ.user_name}}</div>
				<div class="date">{{sQ.date_timestamp | dateFormat1('yyyy-MM-dd hh:mm')}}</div>
				<div class="text">
					<pre class="f-pre" v-html="sQ.content"></pre>
				</div>
			</div>
			<div class="item m-s-a" v-if="showSA">
				<user-avatar :avatar="sA.avatar"></user-avatar>
				<div class="name f-toe1">{{sA.user_name}}</div>
				<div class="date">{{sA.date_timestamp | dateFormat1('yyyy-MM-dd hh:mm')}}</div>
				<div class="text">
					<pre class="f-pre" v-html="sA.content"></pre>
				</div>
			</div>
			<div class="m-status-bar" v-if="showStatus">
				问题状态<span :class="['status', 'status-' + statusCode]">{{statusText}}</span>
			</div>
		</div>
		<div class="m-related" v-if="showRelated">
			<h4 class="m-bt">
				<span class="u-tt">相关问题</span>
			</h4>
			<ul>
				<li v-for="(item, index) of related">
					<a :href="item | path" :class="['ask-link', 'f-toe1', 'status-' + item.status]">{{item.title}}</a>
				</li>
			</ul>
		</div>
		<comment-normal :comments="comments"></comment-normal>
	</page-common>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageCommon from './page-common'
import UserAvatar from './user-avatar'
import CommentNormal from './comment-normal'
import 'styles/page-ask-detail.less'

const statusMap = {
	'0': '待审核',
	'1': '审核通过',
	'2': '办理中',
	'3': '已回复',
	'4': '审核未通过'
}

export default {
	components: {
		PageCommon,
		UserAvatar,
		CommentNormal
	},
	filters: {
		path(item) {
			return '#/ask/detail/' + item.question_id;
		}
	},
	computed: {
		...mapGetters({
			detail: 'ask:detail:detail',
			related: 'ask:detail:related',
			comments: 'ask:detail:comments',
			hasComments: 'ask:detail:hasComments'
		}),
		showDomain() {
			return !Jt.string.isEmpty(this.detail.domain);
		},
		fQ() {
			return this.detail.question || {};
		},
		fA() {
			return this.detail.answer || {};
		},
		sQ() {
			return this.detail.sec_question || {};
		},
		sA() {
			return this.detail.sec_answer || {};
		},
		showFA() {
			let fA = this.fA;
			return !Jt.object.isEmpty(fA) && !Jt.string.isEmpty(fA.content);
		},
		showSQ() {
			let sQ = this.sQ;
			return !Jt.object.isEmpty(sQ) && !Jt.string.isEmpty(sQ.content);
		},
		showSA() {
			let sA = this.sA;
			return !Jt.object.isEmpty(sA) && !Jt.string.isEmpty(sA.content);
		},
		statusCode() {
			return this.detail.status + '';
		},
		statusText() {
			const code = this.statusCode;
			return statusMap[code];
		},
		showStatus() {
			const code = this.statusCode;
			const codes = ['0', '1', '2', '4'];
			if(codes.indexOf(code) === -1) {
				return false;
			}
			return true;
		},
		showRelated() {
			return !Jt.array.isEmpty(this.related);
		}
	},
	watch: {
		'$route': function() {
			this.init(this.$route.params.id);
		}
	},
	created() {
		this.init(this.$route.params.id);
	},
	methods: {
		...mapActions({
			init: 'ask:detail:init'
		})
	}
}

</script>


// WEBPACK FOOTER //
// page-ask-detail.vue?a390f1b0